<template>
  <div class="tabs">
    <div class="mr-12 sm:mr-0">
      <ul
        class="nav nav-tabs"
        role="tablist"
      >
        <li
          class="nav-item"
          role="presentation"
        >
          <a
            class="nav-link"
            role="tab"
            aria-selected="true"
            aria-setsize="2"
            aria-posinset="1"
            :class="{ active: activeTab === 'flight' }"
            data-i18n="preliminaryFlighttimes"
            @click.prevent="activeTab = 'flight'"
          >{{ $t('preliminaryFlighttimes') }}</a>
        </li>
        <li
          v-if="possiblePickups.length > 0"
          class="nav-item"
          role="presentation"
        >
          <a
            class="nav-link"
            role="tab"
            tabindex="-1"
            aria-selected="false"
            aria-setsize="2"
            aria-posinset="2"
            :class="{ active: activeTab === 'boarding' }"
            data-i18n="boardingLocations"
            @click.prevent="activeTab = 'boarding'"
          >{{ $t('boardingLocations') }}</a>
        </li>
        <li
          v-if="overnightGothenburg.length > 0 || overnightMalmo.length > 0"
          class="nav-item"
          role="presentation"
        >
          <a
            class="nav-link"
            role="tab"
            tabindex="-1"
            aria-selected="false"
            aria-setsize="2"
            aria-posinset="3"
            :class="{ active: activeTab === 'overnight' }"
            data-i18n="boardingLocations"
            @click.prevent="activeTab = 'overnight'"
          >{{ $t('boardingLocations') }}</a>
        </li>
      </ul>
    </div>
    <div class="tab-content">
      <div
        class="tab-pane"
        :class="{ active: activeTab === 'flight' }"
        role="tabpanel"
      >
        <CharterItinerarySingle
          class="bg-white"
          :show-luggage="true"
          :flight-offer="compositeFlightOffer"
          :luggage-policies="luggagePolicies"
          :flights-collapsed="false"
        />
      </div>
      <div
        class="tab-pane"
        :class="{ active: activeTab === 'boarding' }"
        role="tabpanel"
      >
        <ul class="mt-6 columns-3 departure-list">
          <li
            v-for="item in possiblePickups"
            :key="item.id"
          >
            <span>
              <strong>
                {{ item.time }}
              </strong>
              <span class="ml-2">
                {{ item.name_text }}
              </span>
            </span>
          </li>
        </ul>
      </div>
      <div
        v-if="overnightGothenburg.length > 0 || overnightMalmo.length > 0"
        class="tab-pane"
        :class="{ active: activeTab === 'overnight' }"
        role="tabpanel"
      >
        <LazyCharterItinerarySingle
          :overnight-gothenburg="overnightGothenburg"
          :luggage-policies="luggagePolicies"
          :overnight-malmo="overnightMalmo"
        />
      </div>
    </div>
  </div>
</template>

<script>
import { faPlaneDeparture, faPlaneArrival } from '@fortawesome/pro-duotone-svg-icons'

export default defineNuxtComponent({
  props: {
    trip: {
      type: Object,
      required: true,
    },

    possiblePickups: {
      type: Array,
      default: () => [],
    },

    flightOffer: {
      type: Array,
      default: () => [],
    },

    overnightGothenburg: {
      type: Array,
      default: () => [],
    },

    overnightMalmo: {
      type: Array,
      default: () => [],
    },

    luggagePolicies: {
      type: Array,
      default: () => [],
    },
  },

  data () {
    return {
      icons: {
        faPlaneDeparture,
        faPlaneArrival,
      },

      activeTab: 'flight',
    }
  },

  computed: {
    compositeFlightOffer () {
      if (!this.flightOffer?.length) {
        return null
      }

      return this.flightOffer.reduce((acc, curr) => {
        return {
          ...acc,
          ...curr,
          itinieraries: [
            ...(acc.itinieraries || []),
            ...curr.itinieraries,
          ],
        }
      }, {})
    },
  },
})
</script>

<style lang="scss">
.departure-list {
  list-style-type: circle;
  padding: 0 1rem;
}
</style>
